export default __webpack_public_path__ + "static/media/data-analyst.ed3d5124.gif";